import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { AppProviders } from '@/app/providers';
import { AppRouter } from '@/router';
import { ErrorBoundary } from '@/app/ErrorBoundary';
import { ScrollToTop } from '@/app/ScrollToTop';
import '@/styles/index.css';

const container = document.getElementById('root');

if (!container) {
  // A clear message rather than a null-reference error five frames deep. This can only
  // happen if index.html has been edited, so name the cause.
  throw new Error('No #root element found. Check that apps/web/index.html still contains it.');
}

createRoot(container).render(
  /**
   * `StrictMode` double-invokes effects and renders in development to surface impure
   * components and missing cleanup. It is deliberately kept on: the bugs it exposes are
   * real, and the alternative is finding them in production instead.
   */
  <StrictMode>
    {/*
      The error boundary is outermost so it also catches a failure inside the providers
      themselves — a malformed env value, for instance, which throws at module load.
    */}
    <ErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <ScrollToTop />
          <AppRouter />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
